import styled, { css } from 'styled-components'
import { fontSize, spacing } from 'themes/styles/dimensions'
import { backgroundColorStyle, borderColorStyle } from './FormInput.styles'

export const StyledTextarea = styled.textarea`
  width: ${props => props.inputWidth || '100%'};
  padding: ${props => props.narrow ? '4px 8px' : '8px'};
  margin-bottom: 2px;
  font-size: ${props => props.textSize || fontSize.milli};
  font-family: 'Libre Baskerville', Baskerville, 'Baskerville Old Face',
    'Hoefler Text', Garamond, 'Times New Roman', serif;
  ${backgroundColorStyle}
  color: ${props => props.color || '#000'};
  border-radius: ${props => props.noRadius ? null : '8px'};
  border: 2px solid;
  ${borderColorStyle};
  border-top: ${props => props.topBorderOnly ? '4px solid lightgrey' : null};

  &::placeholder {
  color: ${props => props.placeholderColor || '#dddfdf'};
}

resize: ${props => props.resizable ? 'vertical' : 'none'}
`
